import React, { useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoChevronBackOutline } from "react-icons/io5";
import "../Styles/AllAgentReviews.css";

function AllAgentReviews() {
  const navigate = useNavigate();
  const location = useLocation();

  const { agentReviews = [], partner } = location.state || {};

  const { totalReviews, averageRating, ratingCounts, roundedRating } =
    useMemo(() => {
      const totalReviews = agentReviews?.length || 0;

      const ratingCounts = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      };

      let totalRating = 0;

      agentReviews?.forEach((review) => {
        const rating = Number(review?.Rating || 0);

        totalRating += rating;

        if (rating >= 1 && rating <= 5) {
          ratingCounts[rating]++;
        }
      });

      const averageRating =
        totalReviews > 0 ? (totalRating / totalReviews).toFixed(1) : "0.0";

      return {
        totalReviews,
        averageRating,
        ratingCounts,
        roundedRating: Math.round(Number(averageRating)),
      };
    }, [agentReviews]);

  const getPercentage = (count) =>
    totalReviews ? (count / totalReviews) * 100 : 0;

  

  return (
    <div className="all-review-page">
      <div className="client-setup-header-main">
        <div className="client-setup-header-left">
          <IoChevronBackOutline
            className="client-setup-back-icon"
            onClick={() => navigate(-1)}
          />

          <img
            src={require("../assests/images/nav_bar_logo.png")}
            alt="Wedluk Logo"
            className="client-setup-logo"
          />
        </div>

        <div className="client-setup-header-right">
          <span> Registered partners </span>
        </div>
      </div>

      <div className="review-overview-card">
        <div className="review-overview-left">
          <h4>Client Reviews</h4>

          <div className="review-rating-number">
            <span>{averageRating}</span>
            <span>/5</span>
          </div>

          <p>Average rating</p>

          {/* <div className="review-stars">
            ★★★★<span>★</span>
          </div> */}
          <div className="review-stars">
            {"★".repeat(roundedRating)}
            {"☆".repeat(5 - roundedRating)}
          </div>
        </div>

        <div className="review-overview-right">
          {[5, 4, 3, 2, 1].map((star) => (
            <div className="rating-row" key={star}>
              <span>{star} ★</span>

              <div className="rating-bar">
                <div
                  style={{
                    width: `${getPercentage(ratingCounts[star])}%`,
                  }}
                />
              </div>

              <span>{ratingCounts[star]}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="reviews-grid">
        {agentReviews?.map((item, index) => (
          <div className="review-box" key={index}>
            <div className="review-user">
              <img
                src={
                  item?.Profile?.User?.ProfilePhotoUrl ||
                  "https://randomuser.me/api/portraits/women/44.jpg"
                }
                alt=""
              />

              <div>
                <h5>{item?.Profile?.User?.FirstName}</h5>

                <div className="review-card-stars">
                  {"★".repeat(item?.Rating || 0)}
                  {"☆".repeat(5 - (item?.Rating || 0))}
                </div>
              </div>
            </div>

            <p>{item?.ReviewComment}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AllAgentReviews;
